import React from "react";
import logger from "logger";
import AngSelect from "Common/Angular/AngSelect";
import { getStyleJSON } from "Utils/Common";
import chsstaticdata from "assets/jsondata/CampaignMapStaticJSON.json";

export default function(props) {
  const {
    label,
    taskConfig,
    setValue,
    setTaskConfigChanges,
    preselectedMap,
  } = props;

  if (!chsstaticdata) {
    return null;
  }

  let selectedCampaign = null;
  if (taskConfig.campaign && chsstaticdata) {
    selectedCampaign = chsstaticdata[taskConfig.campaign];
  } else if (preselectedMap && chsstaticdata) {
    selectedCampaign = chsstaticdata[preselectedMap];
  }

  let selectedChapter = null;
  if (selectedCampaign) {
    selectedCampaign.forEach((chapter) => {
      if (chapter.chapterid === taskConfig.chapter) {
        selectedChapter = chapter;
      }
    });
  }

  return (
    <div style={{ padding: "7px" }}>
      <div
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; padding-top:7px;"
        )}
      >
        {label}
      </div>
      {!preselectedMap && (
        <div
          style={getStyleJSON(
            "padding-left: 0px; padding-right: 0px; padding-top:7px;"
          )}
        >
          <AngSelect
            placeholder="Campaign Type"
            ng-model={taskConfig.campaign}
            options={
              chsstaticdata
                ? Object.keys(chsstaticdata).map((key) => {
                    return {
                      label: key,
                      value: key,
                    };
                  })
                : []
            }
            onChange={({ value }) => {
              setTaskConfigChanges({
                campaign: value,
                chapter: "",
                level: "",
              });
            }}
          />
        </div>
      )}
      <div
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; padding-top:7px;"
        )}
      >
        {selectedCampaign && selectedCampaign.length > 0 && (
          <AngSelect
            placeholder="Campaign Chapter"
            required
            ng-model={taskConfig.chapter}
            options={
              selectedCampaign
                ? selectedCampaign.map((chapter) => {
                    return {
                      label: chapter.chaptername,
                      value: chapter.chapterid,
                    };
                  })
                : []
            }
            onChange={({ value }) => {
              setTaskConfigChanges({
                chapter: value,
                level: "",
              });
            }}
          />
        )}
      </div>
      <div
        style={getStyleJSON(
          "padding-left: 0px; padding-right: 0px; padding-top:7px;"
        )}
      >
        {taskConfig.chapter && taskConfig.chapter.length > 0 && (
          <AngSelect
            placeholder="Chapter Level"
            ng-model={taskConfig.level}
            options={
              selectedChapter.levels
                ? selectedChapter.levels.map((level) => {
                    return {
                      label: level.levelname,
                      value: level,
                    };
                  })
                : []
            }
            onChange={({ value }) => {
              setValue({ target: { value } }, "level");
            }}
          />
        )}
      </div>
    </div>
  );
}
